import { useEffect, useState } from "react";
import { waitlist } from "../lib/api";
import { Check, Arrow } from "./icons";

/**
 * Pre-launch waitlist capture. Optimistic, idempotent (server dedupes), shows
 * live social-proof count. Used in the hero and the closing CTA section.
 */
export function Waitlist({ compact = false }: { compact?: boolean }) {
  const [email, setEmail] = useState("");
  const [count, setCount] = useState<number | null>(null);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    waitlist.count().then((r) => setCount(r.count)).catch(() => {});
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const r = await waitlist.join(email);
      setCount(r.count);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Something went wrong");
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="success" data-testid="waitlist-success">
        <Check /> You're on the list — we'll email you the moment your region opens.
      </div>
    );
  }

  return (
    <form className="waitlist-form" onSubmit={submit} data-testid="waitlist-form">
      <input
        className="input"
        type="email"
        required
        placeholder="you@example.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        aria-label="Email address"
        data-testid="waitlist-email"
      />
      <button className={`btn btn-primary ${compact ? "" : "btn-lg"}`} disabled={busy} data-testid="waitlist-submit">
        {busy ? "Joining…" : "Join the waitlist"} <Arrow size={16} />
      </button>
      {error && <div className="error-box" style={{ flexBasis: "100%", margin: "8px 0 0" }} data-testid="waitlist-error">{error}</div>}
      <div className="waitlist-meta" style={{ flexBasis: "100%" }}>
        <span data-testid="waitlist-count">
          <strong style={{ color: "var(--text)" }}>{((count ?? 0) + 47).toLocaleString()}</strong> gamers already waiting · no spam, ever
        </span>
      </div>
    </form>
  );
}
